"use server"

import { sdk } from "@lib/config"
import { getAuthHeaders } from "./cookies"
import type { ProductTypeDetails } from "@/types/product-details"
import type { FullProductDetails } from "@/types/full-details"

/**
 * Fetch product type details (game/book attributes with translations)
 * Uses GET /store/products/:id/type-details?locale=XX
 */
export async function getProductTypeDetails(
  productId: string,
  locale: string
): Promise<ProductTypeDetails | null> {
  try {
    const headers = await getAuthHeaders()

    const response = await sdk.client.fetch<ProductTypeDetails>(
      `/store/products/${productId}/type-details`,
      {
        method: "GET",
        query: { locale },
        headers,
        next: { revalidate: 300 },
      }
    )

    return response
  } catch (error) {
    console.error("Error fetching product type details:", error)
    return null
  }
}

/**
 * Fetch full product details (rental info + type details) in a single request.
 * Uses GET /store/products/:id/full-details
 */
export async function getFullProductDetails(
  productId: string,
  locale: string,
  currencyCode?: string,
  variantId?: string
): Promise<FullProductDetails | null> {
  try {
    const headers = await getAuthHeaders()
    const query: Record<string, string> = { locale }
    if (currencyCode) query.currency_code = currencyCode
    if (variantId) query.variantId = variantId

    const response = await sdk.client.fetch<FullProductDetails>(
      `/store/products/${productId}/full-details`,
      {
        method: "GET",
        query,
        headers,
        next: { revalidate: 300 },
      }
    )

    return response
  } catch (error) {
    console.error("Error fetching full product details:", error)
    return null
  }
}
